var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component selectable separator",class:{ active: _vm.selected == _vm.component, hovered: _vm.hovered == _vm.component }},[_c('div',{staticClass:"component-type"},[_vm._v(_vm._s(_vm.component.component))]),_c('hr')])}
var staticRenderFns = []

export { render, staticRenderFns }